import React from "react";

export const svgSrc = (svg) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

export default function QuestionImage({ svg, className = "" }) {
  if (!svg) return null;
  return (
    <div className={`question-image ${className}`} data-testid="question-image">
      <img src={svgSrc(svg)} alt="Grafik zur Frage" loading="lazy" />
    </div>
  );
}
